import { Regulations } from '../../api/fishrules/getSpeciesRegulationsAtLocation';
import { Pill } from '../Clickables/Pill/Pill';
import { Heading } from '../Heading/Heading';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { Text } from '../Text/Text';

import { getRestrictionsAndRequirements } from './helpers';

interface IProps {
  regulation: Regulations;
}

export const ProhibitedMethods = ({ regulation }: IProps) => {
  const restrictionsAndRequirements = getRestrictionsAndRequirements(regulation);

  return (
    <>
      {restrictionsAndRequirements.map(({ name, label, description }) => (
        <Modal
          key={name}
          trigger={props => (
            <Pill {...props} variant="error" className="mt-2 mr-2 inline">
              {label}
            </Pill>
          )}
        >
          <ModalBody>
            <Heading variant="sm" className="mb-4">
              {label}
            </Heading>
            <Text className="mb-0">{description}</Text>
          </ModalBody>
        </Modal>
      ))}
    </>
  );
};
